module.exports = __webpack_public_path__ + "img/lew.ff107486.jpg";